// 🔴 [중요] 브랜드별 검색 필터 — multi-brand-hub.md 정책
// HK 스토어는 MATIN KIM / MARITHE 2브랜드 공유.
// 정책: 검색 결과·자동완성 products 만 자기 브랜드 vendor 로 한정. 인기검색어·컬렉션·페이지·아티클은 그대로 둠.
// 이유: Shopify search API 의 q vendor 필터는 ALL resource type 에 적용돼 products 외 영역까지 0 으로 만듦.
//      → predictive 는 q 에 vendor 안 합치고 응답 DOM 에서 products 만 클라이언트 필터.
//      결과 페이지(form submit)는 q 에 vendor 합쳐서 보냄 (search.results 정확성 보장).
// 브랜드 감지: theme.liquid 가 body 에 붙이는 `brand--marithe` / `brand--matinkim` 클래스 (SSOT)
// 도메인 분리 후: theme.liquid 의 is_marithe 로직이 request.host 기반 단일 조건으로 단순화될 예정.
//                여기 JS 는 body 클래스만 보므로 자동 호환.
function __getBrandVendor() {
  const body = document.body;
  if (body.classList.contains('brand--marithe')) return 'MARITHE';
  if (body.classList.contains('brand--matinkim')) return 'MATIN KIM';
  return '';
}

function __getBrandVendorFilter() {
  const v = __getBrandVendor();
  return v ? `vendor:"${v}"` : '';
}

function __appendVendorFilter(query) {
  const filter = __getBrandVendorFilter();
  if (!filter) return query;
  if (/vendor:/i.test(query)) return query; // 이미 포함 시 중복 방지
  return `${query} AND ${filter}`;
}

if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.form = this.querySelector('form');
      this.resultsContainer = this.querySelector(
        '.js-results-container'
      );
      this.btnSubmit = this.querySelector('.js-btn-submit');
      this.btnClearText = this.querySelector('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector(
        '.js-message-error'
      );
      this.errorMessageText =
        this.errorMessageContainer.querySelector('[data-text]');
      this.timeout = null;
      this.isOpen = false;
      this.drawer = this.closest('.js-drawer');

      var searchDrawerContent = document.querySelector('.drawer__content--search');
      var searchSuggestions = document.querySelector('.search-drawer__suggestions');

      this.input.addEventListener('input', e => {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          const searchTerm = this.input.value.trim();

          if (searchTerm.length <= 0) {
            this.close();
            if(DeviceDetector.isMobile()) {
              searchDrawerContent.style.height = 'auto';
            }
            if(searchSuggestions) {
              searchSuggestions.style.display = 'block';
            }
            return;
          }

          this.isOpen = true;
          this.getSearchResults(searchTerm);
          // 🔴 drawer__content 는 자연 height 로 (CSS inset-block-end: unset).
          // results 컨테이너의 absolute trick 제거(component-predictive-search.css) 후
          // search__body height 가 grid + view-results 정상 계산되어 142px cap 문제 없음.
          // height: 100% 강제하면 drawer 가 viewport 풀화면 차지함 — 금지. 회귀 case 박제.
          if(searchSuggestions) {
            searchSuggestions.style.display = 'none';
          }
        }, 300);
      });

      this.input.addEventListener('keydown', e => {
        const isEscape = e.key === 'Escape';

        if (!isEscape) {
          return;
        }

        if (!this.input.value) {
          if (this.drawer) {
            this.drawer.parentElement.parentElement.toggleDrawer();
          }

          return;
        }

        this.close();
      });

      this.btnClearText.addEventListener('click', e => {
        this.close();
        if(DeviceDetector.isMobile()) {
          searchDrawerContent.style.height = 'auto';
        }
        if(searchSuggestions) {
          searchSuggestions.style.display = 'block';
        }
      });

      // 🔴 [2026-07-15] form submit 시 브랜드 격리 = filter.p.vendor 파라미터 (구 'AND vendor:' strict 방식 폐기).
      // q 는 raw 유지(prefix 검색 관대함 보존), 브랜드는 별도 파라미터로 서버 post-filter.
      // input.value 직접 mutation 금지 — submit~navigation 사이 raw 쿼리 깜빡임 발생.
      // main-search.liquid 진입 JS 와 동일 정책. 분석: docs/search-brand-filter-plan-2026-07-15.md
      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          if (!this.input || !this.input.value.trim()) return;
          const raw = this.input.value.trim();
          const brand = __getBrandVendor();
          if (!brand) return; // 브랜드 미확정 → 기본 폼 동작 (필터 없이 검색)
          e.preventDefault();
          const action = this.form.getAttribute('action') || '/search';
          const target = `${action}?q=${encodeURIComponent(raw)}&filter.p.vendor=${encodeURIComponent(brand)}`;
          window.location.assign(target);
        });
      }
    }

    async getSearchResults(searchTerm) {
      try {
        // 🔴 좌측 col 제거 후 products 만 필요 → q 에 vendor 합쳐 서버 필터 (Shopify 가 자기 브랜드 매칭만 반환).
        // multi-brand-hub.md 정책. resources[limit]=10 (Shopify 천장).
        const filteredTerm = __appendVendorFilter(searchTerm);
        const response = await fetch(
          MISTO.localeUrl(`/search/suggest?q=${encodeURIComponent(filteredTerm)}&resources[type]=product&resources[limit]=10&section_id=predictive-search`)
        );

        if (!this.isOpen) {
          return;
        }

        if (!response.ok) {
          const error = new Error(response.status);

          throw error;
        }

        const text = await response.text();
        const parsedDoc = new DOMParser().parseFromString(text, 'text/html');
        const section = parsedDoc.querySelector('#shopify-section-predictive-search');

        // 🔴 항상 4개 keep — viewport 별 표시 개수는 CSS 가 컨트롤.
        // 모바일(<750, 2col): 4개 모두 표시 (2x2). 750+ (3col): 4번째 wrapper 를 CSS 에서 display:none.
        // 이유: resize 후 재검색 없이도 즉시 반영. JS breakpoint 분기 의존 X.
        // CSS: component-predictive-search.css 의 .js-predictive-product:nth-child(n+4)
        const PRODUCTS_LIMIT = 4;
        if (section) {
          const cards = section.querySelectorAll('.js-predictive-product');
          let kept = 0;
          cards.forEach((card) => {
            if (kept < PRODUCTS_LIMIT) {
              kept += 1;
            } else {
              card.remove();
            }
          });
          // 매칭 0개면 Products 컬럼 제거 (빈 헤더 안 보임)
          if (kept === 0) {
            const productsCol = section.querySelector('.predictive-search__col-product');
            if (productsCol) productsCol.remove();
          }
        }

        const resultsMarkup = section.innerHTML;
        this.resultsContainer.innerHTML = resultsMarkup;
        this.open();

        // new added product cards - quick cart triggers - set event listeners
        document.querySelector('quick-cart-drawer')?.initTriggers();

      } catch (error) {
        // 🔴 [2026-05-29] predictive 실패 시 raw 상태코드("417" 등) 화면 노출 금지.
        //   예: 비영어 buyer locale 에서 Shopify /search/suggest 가 417 'Unsupported buyer locale' 반환
        //   (zh-Hant 등 — Shopify 측 predictive 인덱스/로케일 이슈). 조용히 degrade:
        //   에러 박스·드롭다운 숨김 → 손님은 엔터(전체 /search)로 결과 확인. 디버깅용 console 만 남김.
        console.warn('[predictive-search] suggest 실패 — 드롭다운 숨김:', error.message);
        this.errorMessageText.textContent = '';
        this.errorMessageContainer.classList.add('hidden');
        if (this.resultsContainer) this.resultsContainer.classList.add('hidden');
      }
    }

    open() {
      this.classList.add('is-open');
      this.resultsContainer.classList.remove('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.btnSubmit.setAttribute('tabindex', '-1');
      this.btnClearText.removeAttribute('disabled');
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
      this.resultsContainer.classList.add('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.input.value = '';
      this.input.focus();
      this.btnSubmit.removeAttribute('tabindex');
      this.btnClearText.setAttribute('disabled', true);
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}
